module.exports = __webpack_public_path__ + "/images/ico-round-embarazada.f841be3.svg";